import * as i0 from '@angular/core';
import { booleanAttribute, Component, ViewEncapsulation, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i1 from 'ng-zorro-antd/core/outlet';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
function NzDividerComponent_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.nzText);
  }
}
function NzDividerComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 0);
    i0.ɵɵtemplate(1, NzDividerComponent_Conditional_0_ng_container_1_Template, 2, 1, "ng-container", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r0.nzText);
  }
}
let NzDividerComponent = /*#__PURE__*/(() => {
  class NzDividerComponent {
    constructor() {
      this.nzType = 'horizontal';
      this.nzOrientation = 'center';
      this.nzDashed = false;
      this.nzPlain = false;
    }
    static {
      this.ɵfac = function NzDividerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzDividerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NzDividerComponent,
        selectors: [["nz-divider"]],
        hostAttrs: [1, "ant-divider"],
        hostVars: 16,
        hostBindings: function NzDividerComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("ant-divider-horizontal", ctx.nzType === "horizontal")("ant-divider-vertical", ctx.nzType === "vertical")("ant-divider-with-text", ctx.nzText)("ant-divider-plain", ctx.nzPlain)("ant-divider-with-text-left", ctx.nzText && ctx.nzOrientation === "left")("ant-divider-with-text-right", ctx.nzText && ctx.nzOrientation === "right")("ant-divider-with-text-center", ctx.nzText && ctx.nzOrientation === "center")("ant-divider-dashed", ctx.nzDashed);
          }
        },
        inputs: {
          nzText: "nzText",
          nzType: "nzType",
          nzOrientation: "nzOrientation",
          nzDashed: [2, "nzDashed", "nzDashed", booleanAttribute],
          nzPlain: [2, "nzPlain", "nzPlain", booleanAttribute]
        },
        exportAs: ["nzDivider"],
        standalone: true,
        features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 1,
        consts: [[1, "ant-divider-inner-text"], [4, "nzStringTemplateOutlet"]],
        template: function NzDividerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, NzDividerComponent_Conditional_0_Template, 2, 1, "span", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.nzText ? 0 : -1);
          }
        },
        dependencies: [NzOutletModule, i1.NzStringTemplateOutletDirective],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return NzDividerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzDividerModule = /*#__PURE__*/(() => {
  class NzDividerModule {
    static {
      this.ɵfac = function NzDividerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzDividerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NzDividerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [NzDividerComponent]
      });
    }
  }
  return NzDividerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzDividerComponent, NzDividerModule };
